import {Address, ReportLanguage, ScanTypes, Techniques} from "./weak-entities";

export interface Practice {
  Id: string;
  Name: string;
  Logo: string;
  Locations: Location[];
  DisableThermalShift: boolean;
  Techniques: Techniques;
  Metric: boolean;
  UseDefaultScanBg: boolean;
  ReportLanguage: ReportLanguage;
}

export function newPractice(): Practice {
  return {
    Id: '',
    Name: '',
    Logo: '',
    Locations: [],
    DisableThermalShift: false,
    Techniques: 0,
    Metric: false,
    UseDefaultScanBg: true,
    ReportLanguage: ReportLanguage.English,
  }
}

export interface Location {
  Id: string;
  Name: string;
  PhoneNumber: string;
  Email: string;
  Address: Address;
}

export interface PracticeSettings {
  Id?: string;
  PracticeId?: string;
  DoctorId?: string;
  Name: string;
  Context: string;
}

export interface ScanProtocolSettings extends PracticeSettings {
  Options: string;
  Favorite: boolean;
}


export interface ScanLayout extends PracticeSettings {
  LayoutCol: number;
  LayoutRow: number;
  Locations: string;
  CompLocations: string;
  Favorite: boolean;
}

export function newLocation(): Location {
  return {
    Id: '',
    Name: '',
    PhoneNumber: '',
    Email: '',
    Address: {
      Line1: '',
      Line2: '',
      Line3: '',
      City: '',
      StateProvinceCounty: '',
      ZipOrPostcode: '',
      Country: '',
      Other: ''
    },
  }
}

export interface BleGear {
  Id?: string;
  Type: ScanTypes;
  BleId: string;
  Name: string;
}

export enum bluetoothMode {
  noBT,
  activeBT,
  browserBT,
  notActiveBT
}



// WEBPACK FOOTER //
// ./src/model/practice.ts